import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { ResourceIdDto, ResourceTimelineMessagesPageableResponseDto } from '@/api/generated';
import { ResourceTimelineMessagesFormModel } from '@/components/timelineMessages/model/ResourceTimelineMessagesForm.model.ts';

type Req = {
  page: number;
  pageSize: number;
  params: ResourceTimelineMessagesFormModel;
};

type Response = ResourceTimelineMessagesPageableResponseDto;

type Return = {
  getTimelineMessages: (req: Req) => Promise<Response>;
  isError: boolean;
  isLoading: boolean;
};

export const useGetResourceTimelineMessages = (params: { resource: ResourceIdDto }): Return => {
  const { resourceTimelineMessagesApi } = useProcessApiClient();

  const { isError, isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const { data } = await resourceTimelineMessagesApi.getResourcesTimelineMessages(
        params.resource.resourceId,
        params.resource.type,
        req.page,
        req.pageSize,
        {
          ...req.params,
          createdFrom: req.params.createdFrom?.toISOString(),
          createdTo: req.params.createdTo?.toISOString(),
        },
      );
      return data;
    },
  });

  return {
    getTimelineMessages: mutateAsync,
    isError: isError,
    isLoading: isPending,
  };
};
